import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './ToggleButton.module.scss.js';

function ToggleButton(_ref) {
  var onClick = _ref.onClick,
    isChecked = _ref.isChecked,
    disabled = _ref.disabled,
    className = _ref.className,
    dark = _ref.dark,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React.createElement("label", {
    className: classNames(styles.toggleButton, disabled && styles.disabled, dark && styles.dark, className)
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: styles.toggle,
    checked: isChecked,
    onChange: !disabled ? onClick : null,
    id: dataTestId,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.knob
  }));
}
ToggleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  dark: PropTypes.bool,
  dataTestId: PropTypes.string
};
ToggleButton.defaultProps = {
  isChecked: false,
  disabled: false,
  className: '',
  dark: false,
  dataTestId: 'toggleButton'
};

export { ToggleButton as default };
